import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import fetch from '@zillow/fetchier';
import _typeof from '@babel/runtime/helpers/esm/typeof';

var DEFAULT_REQUEST = {
  topnav: {
    format: 'markup'
  },
  footer: {
    format: 'markup'
  },
  metaContent: {
    format: 'markup'
  },
  reg: {
    format: 'markup',
    optional: true
  }
};
var DEFAULT_TIMEOUT = 1000;
var VALID_REQUEST_PARAMS = ['metaContent', 'topnav', 'footer', 'reg',
/* deprecated */
'headTags',
/* deprecated */
'bodyScripts'];

/**
 * Filters out items from the HeadersObject that are of the type 'undefined'
 * @param {Object} headersObject
 * @return {Object}
 */

var buildReqHeadersObj = function buildReqHeadersObj(headersObject) {
  // Convert the object into an array, filter out undefined properties
  var onlyDefinedEntries = Object.entries(headersObject).filter(function (entry) {
    return typeof entry[1] !== 'undefined';
  }); // Convert things back to an object

  return Object.assign.apply(Object, [{}].concat(_toConsumableArray(Array.from(onlyDefinedEntries, function (_ref) {
    var _ref3;

    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return _ref3 = {}, _ref3[k] = v, _ref3;
  }))));
};
/*
 * Helper function to properly build the PFS request object. Docs here:
 * https://zwiki.zillowgroup.net/display/zproddev/Getting+Started+With+Consuming+Page+Frame+Service#GettingStartedWithConsumingPageFrameService-TopLevelRequestStructure
 *
 * @param guid {int} - unique guid for user
 * @param requestId {int} - unique id for the request
 * @param region {int} - regionId
 * @param pfsComponents {obj}
 * @return {obj} - Fully formed request obj to use in a fetch to the page frame service
 */

var buildRequest = function buildRequest(_temp) {
  var _ref4 = _temp === void 0 ? {} : _temp,
      gaTrackingId = _ref4.gaTrackingId,
      guid = _ref4.guid,
      requestId = _ref4.requestId,
      region = _ref4.region,
      headers = _ref4.headers,
      headerVersion = _ref4.headerVersion,
      loginMemento = _ref4.loginMemento,
      sid = _ref4.sid,
      ssid = _ref4.ssid,
      zuid = _ref4.zuid,
      profiles = _ref4.profiles,
      deviceType = _ref4.deviceType,
      _ref4$includeZsg = _ref4.includeZsg,
      includeZsg = _ref4$includeZsg === void 0 ? true : _ref4$includeZsg,
      _ref4$deferDropdowns = _ref4.deferDropdowns,
      deferDropdowns = _ref4$deferDropdowns === void 0 ? false : _ref4$deferDropdowns,
      _ref4$deferScripts = _ref4.deferScripts,
      deferScripts = _ref4$deferScripts === void 0 ? false : _ref4$deferScripts,
      _ref4$staticMarkup = _ref4.staticMarkup,
      staticMarkup = _ref4$staticMarkup === void 0 ? false : _ref4$staticMarkup,
      _ref4$useVisualRefres = _ref4.useVisualRefreshTheme,
      useVisualRefreshTheme = _ref4$useVisualRefres === void 0 ? false : _ref4$useVisualRefres,
      _ref4$pfsComponents = _ref4.pfsComponents,
      pfsComponents = _ref4$pfsComponents === void 0 ? DEFAULT_REQUEST : _ref4$pfsComponents,
      _ref4$timeout = _ref4.timeout,
      timeout = _ref4$timeout === void 0 ? DEFAULT_TIMEOUT : _ref4$timeout,
      includeComscore = _ref4.includeComscore,
      includeGTM = _ref4.includeGTM,
      _ref4$includeFonts = _ref4.includeFonts,
      includeFonts = _ref4$includeFonts === void 0 ? true : _ref4$includeFonts;

  var requestHeaders = _objectSpread({}, headers, {
    'Content-type': 'application/json',
    'X-User-GUID': guid,
    'X-Unique-ID': requestId,
    // backwards compatible headers
    'X-Z-UNIQUE-ID': requestId,
    'X-Z-GUID': guid,
    'X-Z-SID': sid,
    'X-Z-SSID': ssid,
    'X-Z-ZUID': zuid,
    'X-Z-PROFILES': profiles,
    'X-Z-DeviceCategory': deviceType || 'desktop',
    'X-Z-Login-Memento': loginMemento
  });

  var request = {
    method: 'post',
    headers: buildReqHeadersObj(requestHeaders),
    body: _objectSpread({
      region: region,
      gaTrackingId: gaTrackingId
    }, pfsComponents),
    timeout: timeout
  }; // If metaContent is being requested, include the passed or default
  // zsg setting, with precedent given to the defined metaContent object

  if (request.body.metaContent) {
    request.body.metaContent = _objectSpread({
      staticMarkup: staticMarkup,
      useVisualRefreshTheme: useVisualRefreshTheme,
      deferDropdowns: deferDropdowns,
      deferScripts: deferScripts,
      includeZsgCore: includeZsg,
      includeZsgOpt: includeZsg,
      includeComscore: includeComscore,
      includeGTM: includeGTM,
      includeFonts: includeFonts,
      headerVersion: headerVersion
    }, request.body.metaContent);
  }

  return request;
};

var isNodeApp = function isNodeApp() {
  return typeof window === 'undefined';
};

var createDomainInfo = function createDomainInfo(baseUrl, headers) {
  if (headers === void 0) {
    headers = {};
  }

  return {
    baseUrl: baseUrl,
    headers: headers
  };
};

var DOMAIN_INFOS = {
  prod: {
    server: createDomainInfo('https://vpce-034a7767b1cf05fee-85aoz626.execute-api.us-west-2.vpce.amazonaws.com/zillow-prod/statics-zillow-prod/', {
      Host: 'vurrz7mnml.execute-api.us-west-2.amazonaws.com'
    }),
    client: createDomainInfo('https://s.zillowstatic.com/')
  },
  dev: {
    server: createDomainInfo('https://vpce-0bd9933704ef3a1bf-xasos3kx.execute-api.us-west-2.vpce.amazonaws.com/zillow-test/statics-zillow-test/', {
      Host: '22i2yuq2k1.execute-api.us-west-2.amazonaws.com'
    }),
    client: createDomainInfo('https://s.zillow.net/')
  }
};
/**
 * Reference on the private S3 API Gateway:
 * - https://zwiki.zillowgroup.net/pages/viewpage.action?pageId=228248093&refresh=1659466371789&focusedCommentId=372256047&refresh=1659470752520#comment-372256047
 *
 * If it is node app, determine fallback to private s3 domain
 * otherwise fallback to CDN domain
 * @param {String} host
 * @returns {String}
 */

var getS3DomainInfoFromPFSHost = function getS3DomainInfoFromPFSHost(host) {
  var env = host.includes("pf-int.del.zillow.local") || host.includes("pf.zillow.com") || host.includes("pf-int.prod.kong.zg-int.net") ? "prod" : "dev";
  var target = isNodeApp() ? 'server' : 'client';
  return DOMAIN_INFOS[env][target];
};
/**
 * Does request param item have the passed format?
 * @param {Object} item pfs request body item with value { format }
 * @param {String} format format to validate against
 * @returns {Boolean}
 */


var isItemOfFormat = function isItemOfFormat(item, format) {
  return item.format === format;
};
/**
 * Is headTags and bodyScripts of format jsonObject? This request is specifically for NSA
 * @param {Object} param.headTags
 * @param {Object} param.bodyScripts
 * @returns {Boolean}
 */


var isRequestJsonObject = function isRequestJsonObject(_ref) {
  var _ref$metaContent = _ref.metaContent,
      metaContent = _ref$metaContent === void 0 ? {} : _ref$metaContent;
  return isItemOfFormat(metaContent, 'jsonObject');
};
/**
 * Do all request params match the passed format?
 * @param {Object} requestBody object with valid requet params (topnav, footer, etc)
 * @param {String} format
 * @returns {Boolean}
 */


var isRequestAllOfFormat = function isRequestAllOfFormat(requestBody, format) {
  var requestItems = [];
  VALID_REQUEST_PARAMS.forEach(function (key) {
    if (Object.prototype.hasOwnProperty.call(requestBody, key) && _typeof(requestBody[key]) === 'object') {
      requestItems.push(requestBody[key]);
    }
  });

  if (requestItems.length === 0) {
    return false;
  } // for loop so we can short circuit


  for (var ctr = 0; ctr < requestItems.length; ctr += 1) {
    if (!isItemOfFormat(requestItems[ctr], format)) {
      return false;
    }
  }

  return true;
};
/**
 * Get fallback from CDN
 * @param {String*} pfsHost host to determine whether to use prod or test cdn
 * @param {String} type current supported types = ['markup', 'json', 'jsonObject']
 * @returns {Object}
 */


var getFallbackFromStatics = function getFallbackFromStatics(pfsHost, type) {
  if (type) {
    var _getS3DomainInfoFromP = getS3DomainInfoFromPFSHost(pfsHost),
        baseUrl = _getS3DomainInfoFromP.baseUrl,
        headers = _getS3DomainInfoFromP.headers;

    var fallbackPath = baseUrl + "pfs/backup/" + type + ".txt";
    return fetch(fallbackPath, {
      headers: headers
    }).then(function (res) {
      return res.text();
    }).then(function (response) {
      return JSON.parse(response);
    }).catch(function (e) {
      throw new Error("pfs-client error: error retrieving or parsing PFS fallback:  " + e);
    });
  }

  throw new Error('pfs client error: no fallback available that matches request parameters');
};
/**
 * get fallback type based on contents of requestBody
 * @param {Object} requestBody
 * @returns {String}
 */


var getFallbackType = function getFallbackType(requestBody) {
  if (isRequestAllOfFormat(requestBody, 'markup')) {
    return 'markup';
  }

  if (isRequestAllOfFormat(requestBody, 'json')) {
    return 'json';
  }

  if (isRequestJsonObject(requestBody)) {
    return 'jsonObject';
  }

  return undefined;
};
/**
 * Retrieve fallback from CDN
 * @param {String} pfsHost
 * @param {Object} requestBody
 * @returns {Object}
 */


var getFallback = function getFallback(pfsHost, requestBody) {
  return getFallbackFromStatics(pfsHost, getFallbackType(requestBody));
};

/**
 * Makes an HTTP(S) request to a page frame endpoint.
 * @param config {request} - a 'request' object to be passed to the fetch method
 *                           Recommend using helper methods "buildPFSRequest"
 * @param config {pfsHost} - the pfshost (protocol + domain)
 * @param config {pfsVersion} - version service hash
 *
 * @return {Promise} - Promise that will resolve after the async request completes
 */

var makeRequest = function makeRequest(_ref) {
  var _ref$request = _ref.request,
      request = _ref$request === void 0 ? {} : _ref$request,
      pfsHost = _ref.pfsHost,
      pfsVersion = _ref.pfsVersion,
      _ref$useFallback = _ref.useFallback,
      useFallback = _ref$useFallback === void 0 ? false : _ref$useFallback;

  var requestBody = _objectSpread({}, request.body); // Set pfsVersion to default to current unless host is local


  var retPfsVersion = pfsVersion;

  if (!retPfsVersion) {
    if (pfsHost.startsWith('http://localhost')) {
      retPfsVersion = 'dev';
    } else {
      retPfsVersion = 'current';
    }
  }

  var endpoint = pfsHost + "/" + retPfsVersion + "/app";
  return fetch(endpoint, request).then(function (response) {
    if (response.ok) {
      return response;
    }

    throw new Error("Fetch error at " + endpoint + ": " + response.status + ": " + response.statusText);
  }).then(function (response) {
    return response.json();
  }).catch(function (e) {
    if (useFallback) {
      console.warn("pfs-client error: error with PFS request, attempting to serve fallback.  " + e);
      return getFallback(pfsHost, requestBody);
    }

    throw e;
  });
};

/**
 * Requests the page frame.
 * If there is any type of failure, catch and return the cache'd page frame.
 * @param pageFrameParams {obj}
 * @param pageFrameParams.guid - required for versioning / ab tests
 * @param pageFrameParams.requestId - required for logging
 * @param pageFrameParams.region - optional
 * @param pageFrameParams.pfsComponents - optional set of components to request (defaults to all)
 * @param pageFrameParams.pfsHost - pfs protocol + domain
 * @param pageFrameParams.deferDropdowns - Causes the dropdown menus in the header to be skipped
 * @param pageParams.pfsVersion - pfs version hash, will default to current
 * @return {obj} - a JSON Response from the PFS
 */

var getPageFrame = function getPageFrame(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      gaTrackingId = _ref.gaTrackingId,
      guid = _ref.guid,
      headerVersion = _ref.headerVersion,
      requestId = _ref.requestId,
      region = _ref.region,
      headers = _ref.headers,
      loginMemento = _ref.loginMemento,
      sid = _ref.sid,
      ssid = _ref.ssid,
      zuid = _ref.zuid,
      profiles = _ref.profiles,
      deviceType = _ref.deviceType,
      _ref$pfsComponents = _ref.pfsComponents,
      pfsComponents = _ref$pfsComponents === void 0 ? DEFAULT_REQUEST : _ref$pfsComponents,
      pfsHost = _ref.pfsHost,
      pfsVersion = _ref.pfsVersion,
      includeZsg = _ref.includeZsg,
      deferDropdowns = _ref.deferDropdowns,
      deferScripts = _ref.deferScripts,
      staticMarkup = _ref.staticMarkup,
      useVisualRefreshTheme = _ref.useVisualRefreshTheme,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? DEFAULT_TIMEOUT : _ref$timeout,
      _ref$useFallback = _ref.useFallback,
      useFallback = _ref$useFallback === void 0 ? false : _ref$useFallback,
      includeComscore = _ref.includeComscore,
      includeGTM = _ref.includeGTM,
      includeFonts = _ref.includeFonts;

  if (!pfsHost) {
    return new Promise(function () {
      throw new Error('PFS Client host URL is required');
    });
  }

  if (!guid || !requestId) {
    return new Promise(function () {
      throw new Error('PFS Client requires guid and requestId');
    });
  }

  return makeRequest({
    request: buildRequest({
      gaTrackingId: gaTrackingId,
      guid: guid,
      headerVersion: headerVersion,
      requestId: requestId,
      region: region,
      headers: headers,
      loginMemento: loginMemento,
      sid: sid,
      ssid: ssid,
      zuid: zuid,
      profiles: profiles,
      deviceType: deviceType,
      pfsComponents: pfsComponents,
      timeout: timeout,
      includeZsg: includeZsg,
      deferDropdowns: deferDropdowns,
      deferScripts: deferScripts,
      staticMarkup: staticMarkup,
      includeComscore: includeComscore,
      includeGTM: includeGTM,
      includeFonts: includeFonts,
      useVisualRefreshTheme: useVisualRefreshTheme
    }),
    pfsHost: pfsHost,
    pfsVersion: pfsVersion,
    useFallback: useFallback
  });
};

export { buildRequest as buildPageFrameRequest, getPageFrame, makeRequest as makePageFrameRequest };
